import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { firstValueFrom } from 'rxjs';
import { appRoutes } from './app/app.routes';
import { environment } from './app/environments/environment';
import { sessionHeaderInterceptor } from './app/core/http/session-header.interceptor';
import { tenantAppTokenInterceptor } from './app/core/http/tenant-app-token.interceptor';
import { WidgetSessionService } from './app/core/widget-session/widget-session.service';

registerLocaleData(localeEs);

export function bootstrapWidgetSession(session: WidgetSessionService) {
  return () =>
    environment.useMock
      ? Promise.resolve()
      : firstValueFrom(session.ensureSessionStarted());
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(
      withInterceptors([tenantAppTokenInterceptor, sessionHeaderInterceptor]),
    ),
    provideRouter(appRoutes),
    { provide: LOCALE_ID, useValue: 'es' },
    {
      provide: APP_INITIALIZER,
      useFactory: bootstrapWidgetSession,
      deps: [WidgetSessionService],
      multi: true,
    },
  ],
}).catch((err) => console.error(err));
